
import { defineComponent } from 'vue';
// import { setMeta } from '@/store';
import StoryArchiveList from '@/components/StoryArchiveList.vue';
import getArchiveStories from '@/sanity/requests/archive';

export default defineComponent({
  name: 'Home',
  components: { StoryArchiveList },
  setup() {
    // setMeta({ title: 'Archive' });
    return { ...getArchiveStories() };
  },
});
